import { useCallback } from 'react';

import { useMutation } from '@occc-app/dataAccessLayer/utils';
import { UpdatePromocodeStatus, useUpdatePromocodesStatusMutation } from '@occc/graphql';

export const useUpdatePromocodeStatus = () => {
  const [mutate, { loading }] = useMutation(useUpdatePromocodesStatusMutation);

  const updatePromocodeStatus = useCallback(
    async (params: { promocodeId: string; status: UpdatePromocodeStatus }) => {
      await mutate({
        variables: { input: [{ promocodeId: params.promocodeId, status: params.status }] },
      });
    },
    [mutate],
  );

  return { update: updatePromocodeStatus, isLoading: loading };
};
